import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule, MatPrefix } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr';
import { ImageUploadComponent } from 'src/app/views/components/image-upload/image-upload.component';
import { NumericInputDirective } from '../helpers/phoneDirective';
import { NoDataFoundComponent } from 'src/app/views/components/no-data-found/no-data-found.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxEditorModule } from 'ngx-editor';
import { ComposeMailComponent } from './components/compose-mail/compose-mail.component';
import { CommentsComponent } from './components/comments/comments.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatSelectInfiniteScrollModule } from 'ng-mat-select-infinite-scroll';
import { CallConnectedComponent } from './components/call-connected/call-connected.component';
import { QuillModule } from 'ngx-quill';
import { SpecialCharPipe } from '../pipe/special-char.pipe';
import { CallService } from '../services/call/call.service';
import { DocumentFormatPipe } from '../pipe/document-format.pipe';
import { PermissionsPipe } from '../pipe/permissions.pipe';
import { SafehtmlPipe, SafeNoticePipe } from '../pipe/safehtml.pipe';
import { UnixTimestampToDatePipe } from '../pipe/unix-timestamp-to-date.pipe';
import { JsonParsePipe } from '../pipe/json-parse.pipe';
import { SearchMailComponent } from './components/search-mail/search-mail.component';
import { EmailActivityComponent } from './components/email-activity/email-activity.component';
import { UniversityCommunicationService } from '../services/university-communication/university-communication.service';
import { RoleUsersComponent } from './components/role-users/role-users.component';
import { ComposeMailPopupComponent } from './components/compose-mail-popup/compose-mail-popup.component';
import { MailSidebarComponent } from './components/mail-sidebar/mail-sidebar.component';
import { NewCountryTerritoryComponent } from './components/new-country-territory/new-country-territory.component';
import { TreeViewComponent } from './components/tree-view/tree-view.component';
import { ClickOutsideDirective } from './directive/click-outside.directive';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { AdminNoticePopupComponent } from 'src/app/components/common/header/admin-notice-popup/admin-notice-popup.component';
import { CoventryFormComponent } from 'src/app/views/form-master/coventry-form/coventry-form.component';
import { AruFeedbackComponentForm } from 'src/app/views/form-master/aru-feedback/aru-feedback-form.component';
import { AngilaFormComponent } from 'src/app/views/form-master/angila-form/angila-form.component';
import { CovFeedbackComponent } from 'src/app/views/form-master/cov-feedback/cov-feedback.component';
import { CommonFormComponent } from 'src/app/views/form-master/common-form/common-form.component';
import { GreenwichFormNewComponent } from 'src/app/views/form-master/greenwich-form-new/greenwich-form-new.component';
import { ListViewComponent } from './components/list-view/list-view.component';
import { GridViewComponent } from './components/grid-view/grid-view.component';
import { BreadCrumbAndFilterComponent } from './components/bread-crumb-and-filter/bread-crumb-and-filter.component';
import { GreenwichFeedbackComponent } from 'src/app/views/form-master/greenwich-feedback/greenwich-feedback.component';
import { CommonFeedbackComponent } from 'src/app/views/form-master/common-feedback/common-feedback.component';
import { DocViewerComponent } from './components/doc-viewer/doc-viewer.component';
import { TruncatePipe } from '../pipe/truncate.pipe';
// import { MailBoxService } from '../services/mail-box/mail-box.service';
import { EmailActivityComponentMailbox } from './components/mail-box/email-activity/email-activity.component';
import { MailSidebarComponentMailBox } from './components/mail-box/mail-sidebar/mail-sidebar.component';
import { SearchMailComponentMailBox } from './components/mail-box/search-mail/search-mail.component';
import { NotificationsComponent } from 'src/app/views/notification/notifications/notifications.component';
import { RouterModule } from '@angular/router';
// import { SocketService } from '../services/socket/socket.service';
import { GlobalPaginatorComponent } from './components/global-paginator/global-paginator.component';
import { NgxSummernoteModule } from 'ngx-summernote';
import { SummernoteEditorComponent } from './components/summernote-editor/summernote-editor.component';
import { AutomationSidebarComponent } from './components/automation-sidebar/automation-sidebar.component';
import { InfiniteScrollDirective } from './directive/infinite-scroll.directive';
import { ProfieNumericInputDirective } from '../helpers/profileDirective';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { LazyDropdownComponent } from './components/lazy-dropdown/lazy-dropdown.component';
import { UniversityComponent } from './components/dropdowns/university/university.component';
import { ChipInputComponent } from './components/chip-input/chip-input.component';
import { EventCalenderComponent } from 'src/app/views/components/event-calender/event-calender.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { AgentCompanyComponent } from './components/dropdowns/agent-company/agent-company.component';
import { UserListComponent } from './components/dropdowns/user-list/user-list.component';
import { DatepickerComponent } from './components/datepicker/datepicker.component';
import { SwitchUserListComponent } from 'src/app/components/common/header/switch-user-list/switch-user-list.component';
import { UserListModalComponent } from 'src/app/components/common/header/user-list-modal/user-list-modal.component';
import { FilterTagListComponent } from './components/filter-tag-list/filter-tag-list.component';
import { RmLazyDropdownComponent } from './components/rm-lazy-dropdown/rm-lazy-dropdown.component';
import { QuicsightDashboardComponent } from 'src/app/views/components/quicsight-dashboard/quicsight-dashboard.component';
import { BoardNameComponent } from './components/dropdowns/board-name/board-name.component';
import { NumericInputDirectiveWithFloat } from '../helpers/phoneDirectiveFloat';
import { PowerbiWidgetComponent } from './components/powerbi-widget/powerbi-widget.component';
import { VersionUpdateComponent } from 'src/app/components/common/version-update/version-update.component';
import { DynamicTableComponent } from 'src/app/components/common/dynamic-table/dynamic-table.component';
import { AdminBirthdayNoticeComponent } from 'src/app/views/notice-board/admin-birthday-notice/admin-birthday-notice.component';
import { NoSpaceInputDirective } from '../helpers/noSpaceDirective';
import { NoSpaceAllowCopyPasteInputDirective } from '../helpers/noSpaceDirectiveAllowCV';
import { CommonPopupComponent } from './components/common-popup/common-popup.component';
import { TwoFactorPopUpComponent } from 'src/app/components/common/two-factor-pop-up/two-factor-pop-up.component';

@NgModule({
    declarations: [
        ImageUploadComponent,
        NumericInputDirective,
        NoSpaceInputDirective,
        NoSpaceAllowCopyPasteInputDirective,
        NumericInputDirectiveWithFloat,
        ProfieNumericInputDirective,
        NoDataFoundComponent,
        ComposeMailComponent,
        CommentsComponent,
        CallConnectedComponent,
        DocumentFormatPipe,
        PermissionsPipe,
        SafehtmlPipe,
        UnixTimestampToDatePipe,
        JsonParsePipe,
        SearchMailComponent,
        EmailActivityComponent,
        RoleUsersComponent,
        ComposeMailPopupComponent,
        MailSidebarComponent,
        NewCountryTerritoryComponent,
        TreeViewComponent,
        ClickOutsideDirective,
        AdminNoticePopupComponent,
        CoventryFormComponent,
        AruFeedbackComponentForm,
        AngilaFormComponent,
        CovFeedbackComponent,
        CommonFormComponent,
        GreenwichFormNewComponent,
        ListViewComponent,
        GridViewComponent,
        BreadCrumbAndFilterComponent,
        GreenwichFeedbackComponent,
        CommonFeedbackComponent,
        DocViewerComponent,              
        TruncatePipe,
        EmailActivityComponentMailbox,
        MailSidebarComponentMailBox,
        SearchMailComponentMailBox,
        // NotificationsComponent,
        GlobalPaginatorComponent,
        SummernoteEditorComponent,
        AutomationSidebarComponent,
        InfiniteScrollDirective,
        LazyDropdownComponent,
        UniversityComponent,
        ChipInputComponent,
        EventCalenderComponent,
        AgentCompanyComponent,
        UserListComponent,
        DatepickerComponent,
        SwitchUserListComponent,
        UserListModalComponent,
        RmLazyDropdownComponent,
        QuicsightDashboardComponent,
        BoardNameComponent,
        PowerbiWidgetComponent,
        VersionUpdateComponent,
        DynamicTableComponent,
        AdminBirthdayNoticeComponent,
        SafeNoticePipe,
        CommonPopupComponent,
        TwoFactorPopUpComponent
    ],
    providers: [
        CallService,
        SpecialCharPipe,  
        PermissionsPipe,
        SafehtmlPipe,
        UnixTimestampToDatePipe,
        JsonParsePipe,
        UniversityCommunicationService,
        // SocketService,
        BreadCrumbAndFilterComponent,
        SafeNoticePipe
    ],
    imports: [
        CommonModule,
        MatMenuModule,
        MatCardModule,
        MatTableModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatButtonModule,
        MatAutocompleteModule,
        MatBadgeModule,
        MatBottomSheetModule,
        MatButtonToggleModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDatepickerModule,
        MatDialogModule,
        MatDividerModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSlideToggleModule,
        MatSliderModule,
        MatSnackBarModule,
        MatSortModule,
        MatStepperModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        MatTreeModule,
        MatNativeDateModule,
        TranslateModule,
        ToastrModule,
        NgxDropzoneModule,
        NgxMatSelectSearchModule,
        FormsModule,
        ReactiveFormsModule,
        NgxMatSelectSearchModule,
        MatSelectModule,
        NgxMatSelectSearchModule,
        NgxEditorModule,
        // NgxEditorModule,
        ClipboardModule,
        MatSelectInfiniteScrollModule,
        QuillModule,
        CarouselModule,
        RouterModule,
        NgxSummernoteModule,
        ScrollingModule,
        FullCalendarModule,
        NotificationsComponent,
        FilterTagListComponent      
    ],
    exports: [
        MatMenuModule,
        MatCardModule,
        MatTableModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatButtonModule,
        MatAutocompleteModule,
        MatBadgeModule,
        MatBottomSheetModule,
        MatButtonToggleModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDatepickerModule,
        MatDialogModule,
        MatDividerModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSlideToggleModule,
        MatSliderModule,
        MatSnackBarModule,
        MatSortModule,
        MatStepperModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        MatTreeModule,
        MatNativeDateModule,
        MatPrefix,
        TranslateModule,
        ToastrModule,
        ImageUploadComponent,
        NumericInputDirective,
        NoSpaceInputDirective,
        NoSpaceAllowCopyPasteInputDirective,
        NumericInputDirectiveWithFloat,
        ProfieNumericInputDirective,
        NoDataFoundComponent,
        NgxDropzoneModule,
        NgxMatSelectSearchModule,
        FormsModule,
        ReactiveFormsModule,
        NgxMatSelectSearchModule,
        MatSelectModule,
        NgxMatSelectSearchModule,
        NgxEditorModule,
        ComposeMailComponent,
        ClipboardModule,
        MatSelectInfiniteScrollModule,
        QuillModule,
        DocumentFormatPipe,
        PermissionsPipe,
        SafehtmlPipe,
        UnixTimestampToDatePipe,
        JsonParsePipe,
        SearchMailComponent,
        EmailActivityComponent,
        RoleUsersComponent,
        ComposeMailPopupComponent,
        MailSidebarComponent,
        NewCountryTerritoryComponent,
        TreeViewComponent,
        ClickOutsideDirective,
        CoventryFormComponent,
        AruFeedbackComponentForm,
        AngilaFormComponent,
        CovFeedbackComponent,
        CommonFormComponent,
        GreenwichFormNewComponent,
        ListViewComponent,
        GridViewComponent,
        BreadCrumbAndFilterComponent,
        GreenwichFeedbackComponent,
        CommonFeedbackComponent,
        DocViewerComponent,
        CarouselModule,
        AdminNoticePopupComponent,
        TruncatePipe,
        EmailActivityComponentMailbox,
        MailSidebarComponentMailBox,
        SearchMailComponentMailBox,
        //NotificationsComponent,
        GlobalPaginatorComponent,
        SummernoteEditorComponent,
        NgxSummernoteModule,
        AutomationSidebarComponent,
        InfiniteScrollDirective,
        ScrollingModule,
        LazyDropdownComponent,
        UniversityComponent,
        ChipInputComponent,
        EventCalenderComponent,
        FullCalendarModule,
        AgentCompanyComponent,
        UserListComponent,
        DatepickerComponent,
        SwitchUserListComponent,
        UserListModalComponent,
        NotificationsComponent,
        FilterTagListComponent,
        RmLazyDropdownComponent,
        QuicsightDashboardComponent,
        BoardNameComponent,
        PowerbiWidgetComponent,
        VersionUpdateComponent,
        DynamicTableComponent,
        AdminBirthdayNoticeComponent,
        SafeNoticePipe,
        TwoFactorPopUpComponent
    ],
})
export class SharedModule { }
